import { useRouter } from 'next/router'
import { MemberAccessTab as View } from 'ui-components'

import {
  useGetCurrentWorkspaceGuests,
  useGetCurrentWorkspaceMembers
} from '~workspace/queries/useGetWorkspaceById'

export function MemberAccessTab() {
  const router = useRouter()
  const members = useGetCurrentWorkspaceMembers()
  const guests = useGetCurrentWorkspaceGuests()

  const handleTabChange = (event, value) => {
    router.push({ query: { ...router.query, peopleTab: value } })
  }

  return (
    <View
      currentTab={router.query.peopleTab}
      membersCount={members.length}
      guestsCount={guests.length}
      onTabChange={handleTabChange}
    />
  )
}
